{
	"deploymentId": "20260623T205104Z",
	"chainId": 84532,
	"deployedAt": "2026-06-23T20:51:04.894Z",
	"contracts": {
		"FSEnvelopeRegistry": {
			"address": "0xf44FF1a0e37D10959B96C3929D0F28E9a7f12A9d",
			"abiRef": "ff0785f2d6ec18ac54f04caf8944b32e80931b6e0ba747eea0e46e53494cbb12"
		},
		"FSPaymentValidator": {
			"address": "0x97Ec503b02Cf85A56B2B77194Fc3C62bC74a95D5",
			"abiRef": "5c06b1840e1e307bec4b426803081be2250b1a16a89ed3a3272000bfc5fd0d8f"
		},
		"FSAttachmentRelease": {
			"address": "0xF11E568198Ce044f417D094730fcE21b418142ED",
			"abiRef": "bc37a8c681af0849ace7cde4b7005b58679dff2abe8276aaedbdeb31e77ee0e9"
		}
	},
	"transactions": {
		"setSatelliteContracts": "0x2f240d6c68d0bac209022012e203cbea1f3fb5ffc9ce6e8e92bf4cec56500837"
	},
	"deploy": {
		"initialRelayers": [
			"0x0357389806ef93C66B307562D29b4D704D1554a3",
			"0x534c7DA993a6c65977629C0b6deA11ce3320e033"
		]
	}
}
